/**
 * Created by zqy on 2018/8/20 0020.
 */
import request from '@/utils/request'
/*登录
 * @params {username} 用户名
 * @params {password} 密码
 * @params {captcha} 验证码
 * @params {uuid} 获取验证码的随机字符串
* */
export function loginByUsername(username, password,uuid,captcha) {
  const data = {username,password,uuid,captcha}
  return request({
    url: 'jbt/sys/login',
    method: 'post',
    data
  })
}
//退出登录
export function logout() {
  return request({
    url: 'jbt/user/login/logout',
    method: 'post'
  })
}

/*获取管理员列表
* @params {data} 筛选条件
 * page	页数	是	[int]
 * limit	每页显示数	是	[int]
 * username	登录名称		[string]
 * status	状态		[int]
 * showName	显示名称		[string]
 * sidx	排序字段		[string]
 * order	升降序		[string]
 * startTime	开始时间		[int]
 * endTime	结束时间
*
* */
export function fetchAdminList(data) {
  return request({
    url: 'jbt/sys/admin/get-admin-list',
    method: 'post',
    data
  })
}
export function fetchResponsibleList(data) {
    return request({
      url: 'jbt/admin_user/get-responsible-list',
      method: 'post',
      data
    })
  }
/*
* 管理员详情
* @params{id} 管理员id
* */
export function fetchAdminInfo(id) {
  return request({
    url: 'jbt/sys/admin/admin-cloud/query-admin-detail',
    method: 'post',
    data: { id }
  })
}
/*创建管理员
* @params {data} 创建数据
 * nickName	昵称（登录账号）[string]		查看
 * password	密码		[string]		查看
 * userName	用户名		[string]		查看
 * remark	备注		[string]		查看
 * roles	角色Id
* */
export function fetchCreateAdmin(data) {
  return request({
    url: 'jbt/sys/admin/save-or-update-admin',
    method: 'post',
    data
  })
}
/*更新管理员资料
*@params {data} 更新数据
 * id	ID必填	是	[int]		查看
 * nickName	昵称（登录账号）[string]		查看
 * password	密码		[string]		查看
 * userName	用户名		[string]		查看
 * remark	备注		[string]		查看
 * roles	角色Id
* */
export function fetchUpdateAdmin(data) {
  return request({
    url: 'jbt/sys/admin/save-or-update-admin',
    method: 'post',
    data
  })
}

/*
* 管理员是否禁用
* @params {id} 	管理员ID [string] 1,2,3,4
* */
export function fetchUpdateAdminStatus(id){
  const data={id}
  return request({
    url:'jbt/sys/admin/disabled-admin',
    method: 'post',
    data
  })
}

/*
 * 删除、批量删除管理员
 * @params {id} 	管理员ID
 * */
export function fetchDeleteAdmin(ids){
  return request({
    url:'jbt/sys/admin/delete-admin',
    method: 'post',
    data:{ids}
  })
}
//获取当前用户的权限
export function fetchAdminPermissions(){
  return request({
    url:'jbt/sys/permissions/get-admin-permissions',
    method: 'post'
  })
}
//更新当前用户的密码
export function fetchUpdatePassword(data){
  return request({
    // url:'jbt/user/admin/updatePassword',
    url:'jbt/sys/admin/update-mine-password',
    method: 'post',
    data
  })
}
//更新用户的密码
export function fetchAdminPwdUpdate(data){
  return request({
    url:'jbt/sys/admin/update-password',
    method: 'post',
    data
  })
}
//用户负责学校
export function fetchAdminSchool(data){
  return request({
    url:'jbt/admin_school/getSchoolsByAdminId',
    method: 'post',
    data
  })
}
//更新老师的招生学校
export function fetchUpdateEnrollmentSchool(data){
  return request({
    url:'jbt/admin_school/updateEnrollmentSchool',
    method: 'post',
    data
  })
}
//获取招生学校
export function fetchEnrollmentSchool(data){
  return request({
    url:'jbt/admin_school/queryEnrollmentSchool',
    method: 'post',
    data
  })
}




// WEBPACK FOOTER //
// ./src/api/Users/admin.js